module.exports = __webpack_public_path__ + "img/logo.000a1a94.png";